import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250410113957/app/[lng]/(home)/sales_offers/[salesOfferId]/(salesOfferDetail)/SalesOfferDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250410113957/app/[lng]/components/AdsFructidor/RightAdsPanel/RightAdsPanel.tsx");
